import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IChannel,
  IChannelCreate,
  ICheckChannelResponse,
  ICreatorChannelAnalyticsResponse,
} from '../creators.interface';

@Injectable({
  providedIn: 'root',
})
export class CreatorPlatformListService {
  constructor(private readonly http: HttpClient) {}

  public getChannels(params: HttpParams): Observable<IChannel[]> {
    return this.http.get<IChannel[]>('channels', { params });
  }

  public getChannel(channelId: string): Observable<IChannel> {
    return this.http.get<IChannel>(`channels/${channelId}`);
  }

  public refreshChannelIcon(channelId: string): Observable<IChannel> {
    return this.http.put<IChannel>(`channels/${channelId}`, {});
  }

  public refreshChannelIconCurrentCreator(channelId: string): Observable<IChannel> {
    return this.http.put<IChannel>(`channels/current/${channelId}`, {});
  }

  public addChannel(creatorId: string, channel: IChannelCreate): Observable<IChannel> {
    return this.http.post<IChannel>(`channels?creator_id=${creatorId}`, channel);
  }

  public addChannelCurrentCreator(channel: IChannelCreate): Observable<IChannel> {
    return this.http.post<IChannel>(`channels/current`, channel);
  }

  public deleteChannel(channelId: string): Observable<void> {
    return this.http.delete<void>(`channels/${channelId}`);
  }

  public deleteChannelCurrentCreator(channelId: string): Observable<void> {
    return this.http.delete<void>(`channels/current/${channelId}`);
  }

  public getCreatorAnalyticsByCreatorId(creatorId: string): Observable<ICreatorChannelAnalyticsResponse[]> {
    return this.http.get<ICreatorChannelAnalyticsResponse[]>(`creator-analytics/${creatorId}`);
  }

  public getAdminCreatorAnalyticsByCreatorId(creatorId: string): Observable<ICreatorChannelAnalyticsResponse[]> {
    return this.http.get<ICreatorChannelAnalyticsResponse[]>(`creator-analytics/admin/${creatorId}`);
  }

  public getCreatorAnalyticsByCurrentCreator(): Observable<ICreatorChannelAnalyticsResponse[]> {
    return this.http.get<ICreatorChannelAnalyticsResponse[]>(`creator-analytics/current`);
  }

  public checkChannel(channel: IChannelCreate): Observable<ICheckChannelResponse> {
    return this.http.post<ICheckChannelResponse>('channels/check', channel);
  }

  public getValidPlatforms(): Observable<string[]> {
    return this.http.get<string[]>('channels/valid-platforms');
  }
}
